module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "homepage"
    }
  }, [_c('div', {
    staticClass: "top-baner",
    staticStyle: {
      "background-color": "rgb(207, 207, 207)"
    }
  }, [_c('div', {
    staticClass: "arrows"
  }, [_c('div', {
    staticClass: "swiper-container main-slider-6",
    attrs: {
      "data-loop": "1",
      "data-speed": "900",
      "data-center": "0",
      "data-slides-per-view": "1"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide active",
    attrs: {
      "data-val": "0"
    }
  }, [_c('div', {
    staticClass: "clip"
  }, [_c('div', {
    staticClass: "bg bg-bg-chrome act",
    staticStyle: {
      "background-url (data": "image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
    },
    attrs: {
      "data-echo-background": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_1400/v1513751346/DSC02131_kzeohx.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-7 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "main-title style-3 left"
  }, [_c('p', {
    staticClass: "color-white-light1"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide",
    attrs: {
      "data-val": "1"
    }
  }, [_c('div', {
    staticClass: "clip"
  }, [_c('div', {
    staticClass: "bg bg-bg-chrome act",
    attrs: {
      "data-echo-background": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_1400/v1513750952/DSC02079_y92kyl.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1"
  }, [_c('div', {
    staticClass: "main-title style-3 left",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "id": "slider2text"
    }
  }, [_c('h1', [_c('span', {
    staticClass: "color-sea"
  }, [_vm._v("Descanso")]), _vm._v("\n                                                y tranqilidad\n                                            ")]), _vm._v(" "), _c('p', {
    staticClass: "color-white-light"
  }, [_vm._v("Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse\n                                                id pharetra lacus, et hendrerit mi quis leo elementum. Lorem ipsum dolor\n                                                sit.\n                                            ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('a', {
    staticClass: "c-button b-60 bg-sea hv-sea-o delay-2",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("ver mas")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination pagination-hidden poin-style-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-wrapp arr-s-4"
  }, [_c('div', {
    staticClass: "cont-1170"
  }, [_c('div', {
    staticClass: "swiper-arrow-left sw-arrow"
  }, [_c('span', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-arrow-right sw-arrow"
  }, [_c('span', {
    staticClass: "fa fa-angle-right"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top-preview row no-margin"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3 no-padding"
  }, [_c('div', {
    staticClass: "tp_entry"
  }, [_c('div', {
    staticClass: "tp_image"
  }, [_c('img', {
    staticClass: "center-image",
    attrs: {
      "src": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price price-s-2"
  }, [_vm._v("45 minutos")])]), _vm._v(" "), _c('div', {
    staticClass: "tp_content"
  }, [_c('div', {
    staticClass: "rate-wrap"
  }, [_c('div', {
    staticClass: "rate"
  }, [_c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  })]), _vm._v(" "), _c('i', [_vm._v("recomendamos visitar")])]), _vm._v(" "), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cabo San Juan")])])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("disponible todo el año\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3 no-padding"
  }, [_c('div', {
    staticClass: "tp_entry"
  }, [_c('div', {
    staticClass: "tp_image"
  }, [_c('img', {
    staticClass: "center-image",
    attrs: {
      "src": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price price-s-2"
  }, [_vm._v("45 minutos")])]), _vm._v(" "), _c('div', {
    staticClass: "tp_content"
  }, [_c('div', {
    staticClass: "rate-wrap"
  }, [_c('div', {
    staticClass: "rate"
  }, [_c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  })]), _vm._v(" "), _c('i', [_vm._v("recomendamos visitar")])]), _vm._v(" "), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cabo San Juan")])])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("disponible todo el año\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3 no-padding"
  }, [_c('div', {
    staticClass: "tp_entry"
  }, [_c('div', {
    staticClass: "tp_image"
  }, [_c('img', {
    staticClass: "center-image",
    attrs: {
      "src": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price price-s-2"
  }, [_vm._v("45 minutos")])]), _vm._v(" "), _c('div', {
    staticClass: "tp_content"
  }, [_c('div', {
    staticClass: "rate-wrap"
  }, [_c('div', {
    staticClass: "rate"
  }, [_c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  })]), _vm._v(" "), _c('i', [_vm._v("recomendamos visitar")])]), _vm._v(" "), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cabo San Juan")])])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("disponible todo el año\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3 no-padding"
  }, [_c('div', {
    staticClass: "tp_entry"
  }, [_c('div', {
    staticClass: "tp_image"
  }, [_c('img', {
    staticClass: "center-image",
    attrs: {
      "src": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_337/v1513656022/stock-photo-121747485_u2omz9.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "price price-s-2"
  }, [_vm._v("45 minutos")])]), _vm._v(" "), _c('div', {
    staticClass: "tp_content"
  }, [_c('div', {
    staticClass: "rate-wrap"
  }, [_c('div', {
    staticClass: "rate"
  }, [_c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-star color-yellow"
  })]), _vm._v(" "), _c('i', [_vm._v("recomendamos visitar")])]), _vm._v(" "), _c('h4', [_c('b', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Cabo San Juan")])])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("disponible todo el año\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wraper padd-0 "
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "second-title"
  }, [_c('h4', {
    staticClass: "subtitle color-red-3 underline"
  }, [_vm._v("Hostal Pelikan Taganga")]), _vm._v(" "), _c('h2', [_vm._v("Habitaciones")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "top-baner arrows"
  }, [_c('div', {
    staticClass: "swiper-container fly-slider swiper-swiper-unique-id-0 initialized pagination-hidden",
    attrs: {
      "data-autoplay": "0",
      "data-loop": "0",
      "data-speed": "1000",
      "data-slides-per-view": "responsive",
      "data-mob-slides": "1",
      "data-xs-slides": "2",
      "data-sm-slides": "2",
      "data-md-slides": "3",
      "data-lg-slides": "4",
      "data-add-slides": "4",
      "id": "swiper-unique-id-0"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "width": "1172px",
      "transform": "translate3d(0px, 0px, 0px)",
      "transition-duration": "0s",
      "height": "459px"
    }
  }, [_c('div', {
    staticClass: "swiper-slide swiper-slide-visible swiper-slide-active",
    staticStyle: {
      "width": "293px",
      "height": "459px"
    }
  }, [_c('div', {
    staticClass: "hotel-item style-7"
  }, [_c('div', {
    staticClass: "radius-top"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378777/DSC01473_dgsrbd.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("desde\n                                            "), _c('strong', {
    staticClass: "color-red-3"
  }, [_vm._v("20.000 COP")])]), _vm._v(" "), _c('h4', [_c('b', [_vm._v("Dormitorio")])]), _vm._v(" "), _c('p', [_vm._v("Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "c-button b-40 bg-red-3 hv-red-3-o fl",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("book now")]), _vm._v(" "), _c('a', {
    staticClass: "c-button b-40 color-grey-3 hv-o fr",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flag_icon_grey.png",
      "alt": ""
    }
  }), _vm._v("ver mas")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide swiper-slide-visible",
    staticStyle: {
      "width": "293px",
      "height": "459px"
    }
  }, [_c('div', {
    staticClass: "hotel-item style-7"
  }, [_c('div', {
    staticClass: "radius-top"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378640/DSC01385_ky8tm8.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("desde\n                                            "), _c('strong', {
    staticClass: "color-red-3"
  }, [_vm._v("20.000 COP")])]), _vm._v(" "), _c('h4', [_c('b', [_vm._v("Dormitorio")])]), _vm._v(" "), _c('p', [_vm._v("Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "c-button b-40 bg-red-3 hv-red-3-o fl",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("book now")]), _vm._v(" "), _c('a', {
    staticClass: "c-button b-40 color-grey-3 hv-o fr",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flag_icon_grey.png",
      "alt": ""
    }
  }), _vm._v("ver mas")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide swiper-slide-visible",
    staticStyle: {
      "width": "293px",
      "height": "459px"
    }
  }, [_c('div', {
    staticClass: "hotel-item style-7"
  }, [_c('div', {
    staticClass: "radius-top"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513378821/DSC01484_p6lvat.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("desde\n                                            "), _c('strong', {
    staticClass: "color-red-3"
  }, [_vm._v("20.000 COP")])]), _vm._v(" "), _c('h4', [_c('b', [_vm._v("Dormitorio")])]), _vm._v(" "), _c('p', [_vm._v("Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "c-button b-40 bg-red-3 hv-red-3-o fl",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("book now")]), _vm._v(" "), _c('a', {
    staticClass: "c-button b-40 color-grey-3 hv-o fr",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flag_icon_grey.png",
      "alt": ""
    }
  }), _vm._v("ver mas")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide swiper-slide-visible",
    staticStyle: {
      "width": "293px",
      "height": "459px"
    }
  }, [_c('div', {
    staticClass: "hotel-item style-7"
  }, [_c('div', {
    staticClass: "radius-top"
  }, [_c('img', {
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_265/v1513380734/DSC01463_meygti.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("desde\n                                            "), _c('strong', {
    staticClass: "color-red-3"
  }, [_vm._v("20.000 COP")])]), _vm._v(" "), _c('h4', [_c('b', [_vm._v("Dormitorio")])]), _vm._v(" "), _c('p', [_vm._v("Dormitorio con baño privado, ideal cuando viajas con tu grupo de amigos\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticClass: "c-button b-40 bg-red-3 hv-red-3-o fl",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("book now")]), _vm._v(" "), _c('a', {
    staticClass: "c-button b-40 color-grey-3 hv-o fr",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/flag_icon_grey.png",
      "alt": ""
    }
  }), _vm._v("ver mas")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination poin-style-2 pagination-swiper-unique-id-0"
  }, [_c('span', {
    staticClass: "swiper-pagination-switch swiper-visible-switch swiper-active-switch",
    staticStyle: {
      "display": "inline-block"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swiper-pagination-switch swiper-visible-switch",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swiper-pagination-switch swiper-visible-switch",
    staticStyle: {
      "display": "none"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "swiper-pagination-switch swiper-visible-switch",
    staticStyle: {
      "display": "none"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-arrow-left offers-arrow color-4"
  }, [_c('span', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-arrow-right offers-arrow color-4"
  }, [_c('span', {
    staticClass: "fa fa-angle-right"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wraper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "second-title"
  }, [_c('h4', {
    staticClass: "subtitle color-dark-2-light"
  }, [_vm._v("Hostal Pelikan Taganga")]), _vm._v(" "), _c('h2', [_vm._v("Nuestro servicios")]), _vm._v(" "), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v("Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "/static/img/theme-1/c_icon_1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "icon-title color-dark-2"
  }, [_vm._v("Daily cleaning service")]), _vm._v(" "), _c('div', {
    staticClass: "icon-text color-dark-2-light"
  }, [_vm._v("Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.")]), _vm._v(" "), _c('a', {
    staticClass: "c-button small bg-sea-t hv-sea-t delay-2",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("ver mas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "/static/img/theme-1/c_icon_2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "icon-title color-dark-2"
  }, [_vm._v("24/7 security and reception")]), _vm._v(" "), _c('div', {
    staticClass: "icon-text color-dark-2-light"
  }, [_vm._v("Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.")]), _vm._v(" "), _c('a', {
    staticClass: "c-button small bg-sea-t hv-sea-t delay-2",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("ver mas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "/static/img/theme-1/c_icon_3.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "icon-title color-dark-2"
  }, [_vm._v("Gratis wifi (8Mb/s)")]), _vm._v(" "), _c('div', {
    staticClass: "icon-text color-dark-2-light"
  }, [_vm._v("Disfruta de nuestro servicio WiFi las 24 horas, en todo el hostal para que no pierdas comunicación en ningún instante.\n\nEnjoy our WiFi service 24 hours around the hostel so you do not miss any instant communication.")]), _vm._v(" "), _c('a', {
    staticClass: "c-button small bg-sea-t hv-sea-t delay-2",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("ver mas")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-3"
  }, [_c('div', {
    staticClass: "icon-block"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": "/static/img/theme-1/c_icon_4.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "icon-title color-dark-2"
  }, [_vm._v("in bussines")]), _vm._v(" "), _c('div', {
    staticClass: "icon-text color-dark-2-light"
  }, [_vm._v("Sed sit amet leo orci. Fusce tincidunt accumsan pretium. Donec fermentum, ex non placerat.")]), _vm._v(" "), _c('a', {
    staticClass: "c-button small bg-sea-t hv-sea-t delay-2",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("ver mas")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wraper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "second-title"
  }, [_c('h2', [_vm._v("Lugares cerca de ti")]), _vm._v(" "), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v("Hostal Pelikan Taganga")])])])]), _vm._v(" "), _c('div', {
    staticClass: "isotope-container row row10"
  }, [_c('div', {
    staticClass: "grid-sizer col-mob-12 col-xs-6 col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "item gal-item col10 col-mob-12 col-xs-6 col-sm-6"
  }, [_c('a', {
    staticClass: "black-hover",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-full img-responsive",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_580/v1513656026/stock-photo-140004939_vx6pay.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tour-layer delay-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "date color-white"
  }, [_vm._v("July\n                                    "), _c('strong', [_vm._v("19th")]), _vm._v(" to July\n                                    "), _c('strong', [_vm._v("26th")])]), _vm._v(" "), _c('h4', {
    staticClass: "color-white"
  }, [_c('b', [_vm._v("tours in taganga")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item gal-item col10 col-mob-12 col-xs-6 col-sm-3"
  }, [_c('a', {
    staticClass: "black-hover",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-full img-responsive",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_285/v1513656022/stock-photo-121747485_u2omz9.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tour-layer delay-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "date color-white"
  }, [_vm._v("July\n                                    "), _c('strong', [_vm._v("19th")]), _vm._v(" to July\n                                    "), _c('strong', [_vm._v("26th")])]), _vm._v(" "), _c('h4', {
    staticClass: "color-white"
  }, [_c('b', [_vm._v("tours in taganga")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item gal-item col10 col-mob-12 col-xs-6 col-sm-3"
  }, [_c('a', {
    staticClass: "black-hover",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-full img-responsive",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_285/v1513655993/stock-photo-50111228_lti995.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tour-layer delay-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "date color-white"
  }, [_vm._v("July\n                                    "), _c('strong', [_vm._v("19th")]), _vm._v(" to July\n                                    "), _c('strong', [_vm._v("26th")])]), _vm._v(" "), _c('h4', {
    staticClass: "color-white"
  }, [_c('b', [_vm._v("tours in taganga")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "item gal-item col10 col-mob-12 col-xs-6 col-sm-6"
  }, [_c('a', {
    staticClass: "black-hover",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-full img-responsive",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_fill,w_580,h_185/v1513657980/DSC01679_hkdikz.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tour-layer delay-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "vertical-align"
  }, [_c('div', {
    staticClass: "date color-white"
  }, [_vm._v("July\n                                    "), _c('strong', [_vm._v("19th")]), _vm._v(" to July\n                                    "), _c('strong', [_vm._v("26th")])]), _vm._v(" "), _c('h4', {
    staticClass: "color-white"
  }, [_c('b', [_vm._v("tours in taganga")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wraper"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "second-title"
  }, [_c('h4', {
    staticClass: "subtitle color-dark-2-light"
  }, [_vm._v("testimonials")]), _vm._v(" "), _c('h2', [_vm._v("what our clients say")]), _vm._v(" "), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v("Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "arrows bg-bluejeans"
  }, [_c('div', {
    staticClass: "swiper-container main-slider-7",
    attrs: {
      "data-autoplay": "0",
      "data-loop": "1",
      "data-speed": "900",
      "data-center": "0",
      "data-slides-per-view": "1"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide active",
    attrs: {
      "data-val": "0"
    }
  }, [_c('div', {
    staticClass: "sl-bg"
  }, [_c('img', {
    staticClass: "center-image",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "https://res.cloudinary.com/dxmudfvor/image/upload/c_scale,w_378/v1513669975/22045879_1476305649084474_7587987462714636982_n_zo2fel.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-5 col-md-offset-1"
  }, [_c('div', {
    staticClass: "sl-testimonals"
  }, [_c('div', {
    staticClass: "tour-info"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/calendar_icon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "font-style-2 color-white"
  }, [_vm._v("July\n                                                    "), _c('b', [_vm._v(" 19th")]), _vm._v(" to July\n                                                    "), _c('b', [_vm._v(" 26th")])])]), _vm._v(" "), _c('h3', {
    staticClass: "color-white underline"
  }, [_vm._v("Juliana y Jose")]), _vm._v(" "), _c('p', {
    staticClass: "f-14 color-white"
  }, [_vm._v("“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor\n                                                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis\n                                                nostrud exercitation.”")]), _vm._v(" "), _c('img', {
    staticClass: "sl-img",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sl-img",
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "sl-img",
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "src": "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
      "data-echo": "/static/img/home_7/sl_3.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination pagination-hidden poin-style-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow-wrapp arr-s-4"
  }, [_c('div', {
    staticClass: "cont-1170"
  }, [_c('div', {
    staticClass: "swiper-arrow-left sw-arrow"
  }, [_c('span', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "swiper-arrow-right sw-arrow"
  }, [_c('span', {
    staticClass: "fa fa-angle-right"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-wraper padd-90"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-sm-offset-2"
  }, [_c('div', {
    staticClass: "second-title"
  }, [_c('h4', {
    staticClass: "subtitle color-dark-2-light"
  }, [_vm._v("Mejor compartir")]), _vm._v(" "), _c('h2', [_vm._v("Apoyos y amigos")]), _vm._v(" "), _c('p', {
    staticClass: "color-grey"
  }, [_vm._v("Curabitur nunc erat, consequat in erat ut, congue bibendum nulla. Suspendisse id tor.")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-container",
    attrs: {
      "data-autoplay": "0",
      "data-loop": "1",
      "data-speed": "1000",
      "data-center": "0",
      "data-slides-per-view": "responsive",
      "data-mob-slides": "1",
      "data-xs-slides": "2",
      "data-sm-slides": "3",
      "data-md-slides": "4",
      "data-lg-slides": "5",
      "data-add-slides": "6"
    }
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, [_c('div', {
    staticClass: "swiper-slide"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide text-center"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide text-center"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide text-center"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide text-center"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-slide text-center"
  }, [_c('div', {
    staticClass: "partner-entry"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "/static/img-responsive",
    attrs: {
      "src": "https://via.placeholder.com/110x91?text=Logo",
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination pagination-hidden"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77b96af5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Homepage.vue
// module id = 17
// module chunks = 0